(() => {
  const roots = document.querySelectorAll('[data-power-details]');
  if (!roots.length) return;

  const decode = (value) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value || '';
    return textarea.value.replace(/\s+/g, ' ').trim();
  };
  const safe = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[character]);
  const paragraph = (heading, text) => `<p><strong>${safe(heading)}</strong>${safe(text)}</p>`;
  const field = (label, value, parts) => ({
    label,
    value: value || 'Ikke oplyst',
    body: parts.map(([heading, text]) => paragraph(heading, text)).join('')
  });
  const formatInteger = (number) => Number(number).toLocaleString('da-DK');
  const findCapacity = (text) => {
    const match = text.match(/(\d{1,3}(?:[.,]\d{3})+|\d{4,5})\s*mAh\b/i);
    return match ? Number(match[1].replace(/[.,]/g, '')) : null;
  };
  const findPower = (text, title) => {
    const match = text.match(/Maks\s+ladehastighed(?:\s+via\s+kabel)?\s*:\s*(\d+(?:[.,]\d+)?)\s*W/i)
      || text.match(/USB-C\s+opladning\s+med\s+op\s+til\s+(\d+(?:[.,]\d+)?)\s*W/i)
      || title.match(/\b(\d+(?:[.,]\d+)?)\s*W\b/i);
    return match ? `${match[1].replace('.', ',')} W` : '';
  };
  const findWeight = (text) => {
    const match = text.match(/Vægt\s*:?\s*(\d+(?:[.,]\d+)?)\s*g\b/i);
    return match ? Number(match[1].replace(',', '.')) : null;
  };
  const findConcurrent = (text) => {
    const match = text.match(/(?:oplade\s+)?(\d+)\s+enheder\s+samtidigt/i);
    return match ? Number(match[1]) : null;
  };
  const usbPorts = (text) => {
    const a = /USB[- ]?A\b/i.test(text);
    const c = /USB[- ]?C\b/i.test(text);
    if (a && c) return 'USB-A + USB-C';
    if (c) return 'USB-C';
    if (a) return 'USB-A';
    return 'Se produktspecifikationer';
  };
  const featureData = (title, text) => {
    const whole = `${title} ${text}`;
    return {
      solar: /solcelle|solpanel/i.test(whole),
      wireless: /trådløs\s+(?:opladning|ladehastighed)/i.test(whole),
      fourCables: /4\s+indbyggede\s+kabler/i.test(text),
      builtCable: /indbygget\s+USB[- ]?C\s+kabel/i.test(text),
      display: /display/i.test(whole),
      torch: /lommelygte|\blampe\b/i.test(whole),
      led: /25\s*[-–]\s*50\s*[-–]\s*75\s*[-–]\s*100\s*%/i.test(text)
    };
  };

  const buildPowerbank = (title, text) => {
    const capacity = findCapacity(text);
    const watts = findPower(text, title);
    const grams = findWeight(text);
    const concurrent = findConcurrent(text);
    const features = featureData(title, text);
    const laptop = /Macbook|computere?\s+med\s+USB[- ]?C|lade\s+både\s+mobil\s+og\s+computer/i.test(text);
    const portValue = concurrent ? `${concurrent} enheder` : laptop ? 'Mobil + computer' : usbPorts(text);
    const portText = concurrent
      ? `Produktbeskrivelsen angiver opladning af ${concurrent} enheder samtidigt. Den faktiske effekt kan blive fordelt mellem de tilsluttede enheder.`
      : laptop ? 'Produktbeskrivelsen angiver, at mobil og computer kan oplades samtidig.'
        : `De oplyste tilslutninger er ${portValue}. Kontrollér, at dit kabel passer til enhedens stik.`;

    let specialValue = 'Almindelig kabelopladning';
    let specialParts = [
      ['Enkel i brug.', 'Tilslut enheden med et passende kabel, og oplad powerbanken igen inden næste tur.'],
      ['Hold øje med batteriet.', 'Kontrollér strømstatus før afrejse, så du ved, hvor meget energi der er tilbage.']
    ];
    if (features.solar && features.wireless) {
      specialValue = 'Solcelle + trådløs';
      specialParts = [
        ['Flere måder at oplade på.', 'Denne model kombinerer solcellepanel og trådløs opladning. En kompatibel telefon kan lægges på ladefladen uden kabel.'],
        ['Solceller er et supplement.', 'Panelernes effekt afhænger af direkte sollys. Oplad powerbanken fuldt via kabel før turen.']
      ];
    } else if (features.solar && features.fourCables) {
      specialValue = 'Solpanel + kabler';
      specialParts = [
        ['Praktisk på tur.', 'Modellen har både solpanel og fire indbyggede kabler til flere stiktyper.'],
        ['Planlæg opladningen.', 'Solpanelet er en ekstra mulighed i dagslys, men bør ikke være den eneste strømforsyning. Oplad via kabel før afrejse.']
      ];
    } else if (features.solar) {
      specialValue = 'Solcellepanel';
      specialParts = [
        ['Ekstra strøm fra dagslys.', 'Det indbyggede solpanel kan bidrage til opladningen, når det får direkte lys.'],
        ['Brug kabel som hovedmetode.', 'Solopladning varierer med vejr og placering. Mød op med en fuldt opladet powerbank.']
      ];
    } else if (features.wireless) {
      specialValue = 'Trådløs · 15 W';
      specialParts = [
        ['Oplad uden kabel.', 'Den oplyste maksimale trådløse ladeeffekt er 15 W. Telefonen skal understøtte trådløs opladning.'],
        ['Kabel er også en mulighed.', 'Kabelopladning er nyttig, når du vil minimere energitab eller bruge telefonen under opladningen.']
      ];
    } else if (features.fourCables) {
      specialValue = features.display ? 'Display + 4 kabler' : '4 indbyggede kabler';
      specialParts = [
        ['Kablerne er med.', 'De indbyggede USB-C-, Lightning-, Micro-USB- og USB-A-kabler gør det lettere at oplade forskellige enheder uden løse kabler.'],
        ['Se strømstatus.', features.display ? 'Det indbyggede display viser den resterende batteriprocent.' : 'Kontrollér batteriniveauet før turen.']
      ];
    } else if (features.builtCable) {
      specialValue = 'Display + USB-C kabel';
      specialParts = [
        ['Kabel lige ved hånden.', 'Det indbyggede USB-C-kabel kan bruges til enheder med USB-C-stik.'],
        ['Tydelig strømstatus.', 'Displayet viser den resterende batteriprocent, så du nemmere kan planlægge næste opladning.']
      ];
    } else if (features.display && features.torch) {
      specialValue = 'Display + lygte';
      specialParts = [
        ['Se hvor meget strøm der er tilbage.', 'Displayet viser batteriniveauet som procent i stedet for få indikatorlys.'],
        ['Ekstra lys i tasken.', 'Den indbyggede lygte er nyttig til små opgaver på campingpladsen eller ved strømafbrydelse.']
      ];
    } else if (features.display) {
      specialValue = 'Batteridisplay';
      specialParts = [
        ['Præcis strømstatus.', 'Det indbyggede display viser batteriniveauet som procent.'],
        ['Lettere at planlægge.', 'Du kan se, hvornår powerbanken selv skal oplades igen.']
      ];
    } else if (features.led) {
      specialValue = 'LED-indikator';
      specialParts = [
        ['Strømstatus i trin.', 'Batteriniveauet vises i intervaller på 25, 50, 75 og 100 procent.'],
        ['Hurtigt overblik.', 'Indikatoren er enkel at aflæse, men viser ikke en præcis restprocent.']
      ];
    }

    const chargeField = watts
      ? field('Maks. ladeeffekt', watts, [
        ['Oplyst maksimal effekt.', `Produktbeskrivelsen angiver ${watts}. Det er den maksimale ladeeffekt – ikke en garanti for, at alle tilsluttede enheder lader med denne effekt samtidig.`],
        ['Enheden bestemmer også hastigheden.', 'Telefon, tablet eller computer skal understøtte den relevante ladeprotokol, og kablet skal passe til effekten.']
      ])
      : field('Opladning', 'USB-opladning', [
        ['Ladeeffekten er ikke oplyst.', 'Produktteksten angiver ikke en maksimal effekt i watt, så vi viser ikke et gættet tal.'],
        ['Oplad før brug.', features.solar ? 'Brug USB som hovedmetode og solpanelet som supplement i dagslys.' : 'Oplad powerbanken fuldt via et passende USB-kabel før turen.']
      ]);

    return {
      heading: 'Detaljer om denne powerbank',
      intro: 'Få nemt overblikket over kapacitet, ladehastighed og funktioner',
      fields: [
        field('Kapacitet', capacity ? `${formatInteger(capacity)} mAh` : 'Ikke oplyst', [
          ['Batteriets størrelse.', capacity ? `Den oplyste kapacitet er ${formatInteger(capacity)} mAh. Et højere mAh-tal giver typisk flere opladninger mellem hver gang powerbanken skal i stikkontakten.` : 'Kapaciteten er ikke oplyst i produktbeskrivelsen.'],
          ['Faktisk strøm til telefonen.', 'Noget energi går tabt, når strømmen omformes. Antallet af fulde opladninger afhænger derfor også af telefonens batteri og brug undervejs.']
        ]),
        chargeField,
        field('Tilslutning', portValue, [
          ['Oplad de enheder, du har med.', ` ${portText}`],
          ['Brug det rigtige kabel.', 'USB-A og USB-C beskriver stiktypen; ladehastigheden afhænger også af kabel og enhed.']
        ]),
        field('Ekstra funktioner', specialValue, specialParts),
        field('Vægt', grams !== null ? `${formatInteger(grams)} g` : 'Ikke oplyst', [
          ['Vægten i oppakningen.', grams !== null ? `Powerbanken vejer ${formatInteger(grams)} g. ${grams >= 800 ? 'Den store kapacitet er bedst, når den skal bæres kort eller transporteres i bil.' : 'Det er nyttigt at kende vægten, hvis den skal med i rygsækken.'}` : 'Vægten er ikke oplyst i produktbeskrivelsen.'],
          ['Vælg efter turen.', 'Sammenlign både kapacitet, effekt og vægt – mere batteri betyder normalt også en tungere powerbank.']
        ]),
        field('Kompatibilitet', laptop ? 'Mobil + computer' : 'Telefon og tablet', [
          ['Hvad den er lavet til.', laptop ? 'Produktbeskrivelsen nævner både mobil og computer. Kontrollér, at computeren kan oplades via USB-C, og at den understøtter den tilgængelige effekt.' : 'Produktbeskrivelsen angiver brug med smartphones og tablets. Brug et kompatibelt kabel eller trådløs opladning, hvis modellen understøtter det.'],
          ['Tjek før afrejse.', 'Test powerbanken med dine egne enheder hjemme, så du kender stik og opladningshastighed.']
        ])
      ]
    };
  };

  const buildRadio = (text) => {
    const capacity = findCapacity(text);
    const grams = findWeight(text);
    const size = text.match(/Størrelse\s*:\s*(\d+\s*[x×]\s*\d+\s*[x×]\s*\d+)\s*cm/i);
    return {
      heading: 'Detaljer om denne nødradio',
      intro: 'Få nemt overblikket over radio, strøm, lygte og tilslutninger',
      fields: [
        field('Radiobånd', 'FM + AM', [
          ['Følg med på flere frekvenser.', 'Radioen kan modtage både FM og AM. Det giver flere muligheder for at finde nyheder og information.'],
          ['Uden mobildata.', 'Radiofunktionen er nyttig, når mobilnet eller internet ikke er tilgængeligt.']
        ]),
        field('Powerbank', capacity ? `${formatInteger(capacity)} mAh` : 'Ikke oplyst', [
          ['Indbygget batteri.', capacity ? `Den oplyste batterikapacitet er ${formatInteger(capacity)} mAh, og radioen kan bruges som ekstra strøm til en telefon.` : 'Kapaciteten er ikke oplyst.'],
          ['Til nødsituationer.', 'Antallet af telefonopladninger varierer med telefonens batteri og energitab. Hold radioen opladet før turen.']
        ]),
        field('Strømkilder', 'Solcelle + håndsving', [
          ['Flere måder at skaffe strøm.', 'Radioen har solcelle på toppen og dynamo med håndsving. Begge kan give et supplement, når der ikke er en stikkontakt i nærheden.'],
          ['Forbered dig hjemmefra.', 'Oplad batteriet via USB før afrejse. Sollys og håndsving bør ses som nød- og supplementsløsninger.']
        ]),
        field('Lys', 'Indbygget lygte', [
          ['Lys i samme enhed.', 'Den indbyggede lygte er praktisk i mørke, fx ved camping eller strømafbrydelse.'],
          ['Spar på batteriet.', 'Brug lyset efter behov, hvis radioen også skal holde strøm til nyheder og telefon.']
        ]),
        field('Tilslutning', usbPorts(text), [
          ['USB-porte.', `Produktbeskrivelsen angiver ${usbPorts(text)}. Brug et kabel, der passer til din telefon eller tablet.`],
          ['Test udstyret.', 'Prøv opladning og radio hjemme, så du kender betjeningen, før du får brug for den.']
        ]),
        field('Vægt og størrelse', grams !== null ? `${formatInteger(grams)} g` : 'Ikke oplyst', [
          ['Nem at pakke med.', `Radioen vejer ${grams !== null ? `${formatInteger(grams)} g` : 'en ikke oplyst mængde'}${size ? ` og måler ${size[1].replace(/\s*[x×]\s*/g, ' × ')} cm` : ''}.`],
          ['Fast plads i tasken.', 'Opbevar radio og kabel sammen, så de er lette at finde, når de skal bruges.']
        ])
      ]
    };
  };

  const buildCharger = (title, text) => {
    const watts = findPower(text, title);
    const gan = /\bGaN\b|GAN\s+chip/i.test(text);
    return {
      heading: 'Detaljer om denne oplader',
      intro: 'Få nemt overblikket over effekt, kabel og kompatibilitet',
      fields: [
        field('Ladeeffekt', watts, [
          ['Oplyst maksimal effekt.', `Opladeren er angivet til ${watts}. Enheden bestemmer, hvor høj effekt den faktisk kan modtage.`],
          ['Hurtigopladning kræver samspil.', 'Telefon eller tablet og kabel skal understøtte den relevante ladehastighed.']
        ]),
        field('Tilslutning', 'USB-C', [
          ['Moderne stiktype.', 'Opladeren bruges med USB-C-kabel og passer til enheder, der kan oplades via USB-C.'],
          ['Kontrollér din enhed.', 'Se efter USB-C-stik på telefon, tablet eller tilbehør før køb.']
        ]),
        field('Medfølgende kabel', 'USB-C · 1 m', [
          ['Kabel med i pakken.', 'Produktbeskrivelsen angiver et USB-C til USB-C-kabel på 1 meter.'],
          ['Klar til brug.', 'Har din enhed en anden stiktype, skal du bruge et andet kompatibelt kabel.']
        ]),
        field('Kompatibilitet', 'Mobil + tablet', [
          ['Til flere USB-C-enheder.', 'Produktteksten nævner smartphones, tablets og mindre USB-C-tilbehør som lommelygter.'],
          ['Effekten kan variere.', 'En ældre eller mindre enhed kan vælge at lade langsommere end opladerens maksimum.']
        ]),
        field('Beskyttelse', 'Overspænding', [
          ['Indbygget beskyttelse.', 'Producentens beskrivelse angiver beskyttelse mod overspænding.'],
          ['Brug korrekt udstyr.', 'Undgå beskadigede kabler og stikkontakter, og lad ikke opladeren være dækket til under brug.']
        ]),
        field('Teknologi', gan ? 'GaN-chip' : 'CE-mærket', [
          [gan ? 'Effektiv elektronik.' : 'Angivet til EU-brug.', gan ? 'Produktbeskrivelsen angiver en GaN-chip, som kan reducere varmeudvikling i forhold til ældre opladerdesign.' : 'Produktbeskrivelsen angiver CE-godkendelse til brug i EU.'],
          ['Tjek stik og spænding.', 'Brug opladeren efter produktets anvisninger, især hvis du tager den med til udlandet.']
        ])
      ]
    };
  };

  const buildCoolerBattery = (text) => {
    const capacity = findCapacity(text);
    return {
      heading: 'Detaljer om dette køleboksbatteri',
      intro: 'Få nemt overblikket over kapacitet, driftstid og kompatibilitet',
      fields: [
        field('Kapacitet', capacity ? `${formatInteger(capacity)} mAh` : 'Ikke oplyst', [
          ['Strøm til køleboksen.', `Batteriet har en oplyst kapacitet på ${capacity ? formatInteger(capacity) : 'ukendt antal'} mAh.`],
          ['Driftstiden varierer.', 'Omgivelsestemperatur, køleindstilling og hvor ofte boksen åbnes påvirker forbruget.']
        ]),
        field('Passer til', 'Alpicool / Nordic Peak', [
          ['Kun kompatible kølebokse.', 'Produktbeskrivelsen angiver Alpicool- og Nordic Peak-kølebokse med plads til batteri.'],
          ['Kontrollér batterirummet.', 'Batteriet er ikke en universel powerbank. Tjek at din køleboks har det relevante batterirum før bestilling.']
        ]),
        field('Driftstid', 'Ca. 8–16 timer', [
          ['To oplyste scenarier.', 'Beskrivelsen angiver cirka 8 timer ved kontinuerlig køling og op til cirka 16 timer efter stabilisering under optimale forhold.'],
          ['Ikke en garanti.', 'Høj varme, hyppig åbning og lave temperaturindstillinger kan forkorte driftstiden.']
        ]),
        field('Montering', 'I batterirummet', [
          ['Direkte montering.', 'Batteriet sættes i køleboksens batterirum, så boksen kan bruges uden direkte tilslutning til strøm.'],
          ['Følg vejledningen.', 'Brug kun en kompatibel model, og kontrollér at batteriet sidder korrekt.']
        ]),
        field('Anvendelse', 'Køling på farten', [
          ['Mere fleksibel placering.', 'Batteriet gør køleboksen lettere at bruge ved camping, strandture, festival og korte pauser uden strøm.'],
          ['Planlæg køletiden.', 'Forkøl gerne varer og køleboks, før du bruger batteriet alene.']
        ]),
        field('Når det ikke bruges', 'Sluk eller afmontér', [
          ['Undgå unødigt strømforbrug.', 'Produktbeskrivelsen anbefaler at slukke eller afmontere batteriet, når det ikke er i brug.'],
          ['Opbevar forsvarligt.', 'Følg producentens anvisninger for opladning og opbevaring mellem turene.']
        ])
      ]
    };
  };

  const buildAdapter = () => ({
    heading: 'Detaljer om denne rejseadapter',
    intro: 'Få nemt overblikket over stik, USB-opladning og sikkerhed',
    fields: [
      field('Rejsemål', 'Flere verdensdele', [
        ['Til forskellige stikkontakter.', 'Beskrivelsen nævner bl.a. Europa, USA, Storbritannien, Australien og Japan.'],
        ['Kontrollér destinationen.', 'Tjek altid den konkrete stiktype på rejsemålet, inden du pakker.']
      ]),
      field('USB-tilslutning', 'USB-A + USB-C', [
        ['Oplad flere typer enheder.', 'Adapteren har både USB-A- og USB-C-tilslutning til fx telefon, tablet og powerbank.'],
        ['Antal porte er uklart.', 'Produktbeskrivelsen indeholder modstridende oplysninger om det samlede antal USB-porte; kontrollér dette før køb, hvis antallet er vigtigt.']
      ]),
      field('USB-effekt', 'Op til 20 W', [
        ['Oplyst USB-opladning.', 'USB-C-opladning er angivet til op til 20 W.'],
        ['Enheden bestemmer hastigheden.', 'Telefon og kabel skal understøtte effekten for at opnå den mulige ladehastighed.']
      ]),
      field('Stikkontakt', 'Op til 2.500 W', [
        ['Maksimal belastning.', 'Den universelle stikkontakt er angivet til højst 2.500 W og 10 A.'],
        ['Tjek spændingen.', 'En stikadapter ændrer ikke nødvendigvis apparatets spænding. Kontrollér, at dit apparat kan bruges på destinationens elnet.']
      ]),
      field('Sikring', 'Indbygget 10 A', [
        ['Beskyttelse i adapteren.', 'Beskrivelsen angiver en indbygget 10 A-sikring og plads til en reservesikring.'],
        ['Brug efter anvisningen.', 'Overskrid ikke den maksimale belastning, og brug ikke beskadiget udstyr.']
      ]),
      field('Vægt', '136 g', [
        ['Kompakt i bagagen.', 'Den oplyste vægt er 136 g, og målene er 53 × 54 × 61 mm.'],
        ['Saml rejseudstyret.', 'Pak adapter og opladningskabler sammen, så de er nemme at finde ved ankomst.']
      ])
    ]
  });

  roots.forEach((root) => {
    const source = root.querySelector('[data-power-product-data]');
    if (!source) return;
    let product;
    try {
      product = JSON.parse(source.textContent);
    } catch (error) {
      return;
    }

    const title = decode(product.title);
    const text = decode(product.description);
    let data;
    if (/^nødradio/i.test(title)) data = buildRadio(text);
    else if (/^batteri\s+til\s+kølebokse/i.test(title)) data = buildCoolerBattery(text);
    else if (/rejseadapter/i.test(title)) data = buildAdapter();
    else if (/^\d+\s*W\s+oplader/i.test(title)) data = buildCharger(title, text);
    else data = buildPowerbank(title, text);

    if (!data || data.fields.length !== 6) return;
    root.querySelector('[data-power-heading]').textContent = data.heading;
    root.querySelector('[data-power-intro]').textContent = data.intro;
    root.querySelectorAll('[data-power-detail]').forEach((item, index) => {
      const detail = data.fields[index];
      item.querySelector('[data-detail-label]').textContent = detail.label;
      item.querySelector('[data-detail-value]').textContent = detail.value;
      item.querySelector('[data-detail-body]').innerHTML = detail.body;
    });

    const details = root.querySelectorAll('details');
    details.forEach((detail) => detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      details.forEach((other) => {
        if (other !== detail) other.open = false;
      });
    }));
    root.hidden = false;
  });
})();
